import React, { useEffect, useState } from "react";
import "@/styles/switch-field.css";

type SwitchFieldProps = {
    label?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    rootClassName?: string;
};

export default function SwitchField({ label, checked, onChange, disabled, rootClassName }: SwitchFieldProps) {
    const [isChecked, setIsChecked] = useState(checked);

    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);

    function handleToggle() {
        if (disabled) {
            return;
        }
        var next = !isChecked;
        setIsChecked(next);
        onChange(next);
    }

    var rootClass = "switch-field";
    if (disabled) {
        rootClass += " switch-field--disabled";
    }
    if (rootClassName) {
        rootClass += " " + rootClassName;
    }

    var thumbClass = "switch-field__thumb";
    if (isChecked) {
        thumbClass += " switch-field__thumb--on";
    } else {
        thumbClass += " switch-field__thumb--off";
    }

    return (
        <div className={rootClass} onClick={handleToggle} role="button">
            <span className="switch-field__label">{label}</span>
            <span className="switch-field__track">
                <span className={thumbClass} />
            </span>
        </div>
    );
}
